import React, { useState, useEffect } from "react";
import { Card, Row, Col, Breadcrumb, Form, Button, Spin, message, notification } from "antd";
import Headings from "../../atoms/Headigs";
import { useForm } from "react-hook-form";
import { InputPassword } from "../../atoms/FormElement";
import { changePassword } from "./ducks/services";
import { LoadingOutlined } from "@ant-design/icons";
const antIcon = <LoadingOutlined spin />;

const ChangePassword = () => {
    const [form] = Form.useForm();
    const [load, setLoad] = useState(false);
    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
    } = useForm();

    const password = watch("password");

    const onSubmit = (values) => {
        setLoad(true);
        const payload = { ...values };
        changePassword(payload)
            .then((response) => {
                if (response?.data?.header?.code == 200) {
                    message.success("Password has been changed successfully");
                    form.resetFields(); // Reset Ant Design Form
                    reset(); // Reset react-hook-form state
                } else {
                    notification.error({
                        message: 'Change Password Failed',
                        description: 'The provided information is incorrect',
                        placement: 'bottomRight',
                    });
                }
                setLoad(false);
            })
            .catch((error) => {
                notification.error({
                    message: 'Error',
                    description: error?.response?.data?.header?.message ?? error.message,
                    placement: 'bottomRight',
                });
                setLoad(false);
            });
    };

    return (
        <Spin indicator={antIcon} size="large" spinning={load}>
            <Card className="design-card">
                <Row gutter={[24, 30]}>
                    <Col span={24}>
                        <Headings
                            title="Change Password"
                            titleSize={2}
                            description={`Manage your organization from a single platform`}
                            space={5}
                            descClass="mb-0 c-gray"
                        />
                    </Col>
                    <Col span={24}>
                        <Form layout="vertical" form={form} onFinish={handleSubmit(onSubmit)}>
                            <Row gutter={[24, 30]}>
                                <Col span={24}>
                                    <InputPassword
                                        label="Current Password"
                                        fieldname="currentPassword"
                                        control={control}
                                        initValue=""
                                        iProps={{
                                            size: "large",
                                            placeholder: "Enter current password",
                                        }}
                                        rules={{
                                            required: "Current Password is required"
                                        }}
                                        validate={errors.currentPassword && "error"}
                                        validMessage={errors.currentPassword?.message}
                                    />
                                </Col>
                                <Col span={24}>
                                    <InputPassword
                                        label="New Password"
                                        fieldname="password"
                                        control={control}
                                        initValue=""
                                        iProps={{
                                            size: "large",
                                            placeholder: "Enter new password",
                                        }}
                                        rules={{
                                            required: "New Password is required",
                                            minLength: {
                                                value: 12,
                                                message: "Password must be at least 16 characters",
                                            },
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\+\-=\[\]{};:,.?]).{16,}$/,
                                                message: "Password must be at least 16 characters long and include uppercase, lowercase, a number, and one special character from: !@#$%^&*()_+-=[]{};:,.?"
                                            }
                                        }}
                                        validate={errors.password && "error"}
                                        validMessage={errors.password?.message}
                                    />
                                </Col>
                                <Col span={24}>
                                    <InputPassword
                                        label="Confirm Password"
                                        fieldname="confirmPassword"
                                        control={control}
                                        initValue=""
                                        iProps={{
                                            size: "large",
                                            placeholder: "Confirm new password",
                                        }}
                                        rules={{
                                            required: "Please confirm your password",
                                            validate: (value) =>
                                                value === password || "Passwords do not match",
                                        }}
                                        validate={errors.confirmPassword && "error"}
                                        validMessage={errors.confirmPassword?.message}
                                    />
                                </Col>
                            </Row>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                style={{ marginTop: "9px", width: "49%" }}>
                                Update
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Spin>
    );

};
export default ChangePassword;